<template>
  <div class="app-menu">
    <div class="app-logo">
      <div><img src="@/assets/img/logo.png" alt="logo" style="width: 42px;border-radius: 10px" ></div>
	  <div class="title" v-show="!showMenuMini">大熊兼职</div>
    </div>
    <vue-scroll>
      <Menu
        v-show="!showMenuMini"
        ref="menu"
        theme="dark"
        width="auto"
        :active-name="activeName"
        :accordion="true"
        :open-names="openMenuNames"
        @on-select="selectSubMenu">
        <div :key="index" v-for="(item, index) in menu">
          <Submenu :name="item.meta.label" v-if="item.list && item.list.length">
            <template slot="title">
              <Icon :type="item.meta.icon" v-if="item.meta.icon" />
              <Icon :custom="item.meta.customIcon" v-else-if="item.meta.customIcon" />
              <span>{{item.meta.label}}</span>
            </template>
            <div v-for="(childItem, childIndex) in item.list" :key="index + childIndex">
              <Submenu :name="childItem.meta.label + ' '" v-if="childItem.list && childItem.list.length">
                <template slot="title">
                  <Icon :type="childItem.meta.icon" v-if="childItem.meta.icon" />
                  <Icon :custom="childItem.meta.customIcon" v-else-if="childItem.meta.customIcon" />
                  <span>{{childItem.meta.label}}</span>
                </template>
                <MenuItem :name="subItem.path || ''" v-for="(subItem, subIndex) in childItem.list" :key="index + childIndex + subIndex">
                  <Icon :type="subItem.meta.icon" v-if="subItem.meta.icon" />
                  <Icon :custom="subItem.meta.customIcon" v-else-if="subItem.meta.customIcon" />
                  <span>{{subItem.meta.label}}</span>
                </MenuItem>
              </Submenu>
              <MenuItem v-else :name="childItem.path || ''">
                <Icon :type="childItem.meta.icon" v-if="childItem.meta.icon" />
                <Icon :custom="childItem.meta.customIcon" v-else-if="childItem.meta.customIcon" />
                <span>{{childItem.meta.label}}</span>
              </MenuItem>
            </div>
          </Submenu>
          <MenuItem :name="item.path || ''" class="app-menu__single-item">
            <Icon :type="item.meta.icon" v-if="item.meta.icon" />
            <Icon :custom="item.meta.customIcon" v-else-if="item.meta.customIcon" />
            <span>{{item.meta.label}}</span>
          </MenuItem>
        </div>
      </Menu>
      <div v-show="showMenuMini" class="app-menu-mini">
        <div :key="index" v-for="(item, index) in menu">
          <Dropdown
            :placement="placement"
            transfer
            v-if="item.list && item.list.length"
            @on-click="selectSubMenu"
            class="app-menu-mini__dropdown"
            transfer-class-name="app-menu-mini__transfer">
            <a
              @mouseover="handleMousemove($event, item.list)"
              class="app-menu-mini__item"
              :class="{'app-menu-mini__active': openMenuNames[0] === item.meta.label }">
              <span>
                <Icon :type="item.meta.icon" v-if="item.meta.icon" />
                <Icon :custom="item.meta.customIcon" v-else-if="item.meta.customIcon" />
              </span>
            </a>
            <DropdownMenu slot="list">
              <div v-for="(childItem, childIndex) in item.list" :key="index + childIndex">
                <Dropdown :placement="subPlacement" v-if="childItem.list && childItem.list.length">
                  <a
                    @mouseover="handleMousemove($event, childItem.list, true)"
                    :class="{'app-menu-mini__active': openMenuNames[1] === childItem.meta.label }">
                    {{childItem.meta.label}}
                    <Icon type="ios-arrow-forward" />
                  </a>
                  <DropdownMenu slot="list">
                    <DropdownItem
                      v-for="(subItem, subIndex) in childItem.list"
                      :name="subItem.path"
                      :key="index+childIndex+subIndex"
                      :class="{'app-menu-mini__active': activeName === subItem.path }">
                      {{subItem.meta.label}}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <DropdownItem
                  v-else
                  :name="childItem.path"
                  class="app-menu-mini__transfer--sub"
                  :class="{'app-menu-mini__active': activeName === childItem.path }">
                  {{childItem.meta.label}}
                </DropdownItem>
              </div>
            </DropdownMenu>
          </Dropdown>
          <Tooltip v-else :content="item.meta.label" transfer placement="right" class="app-menu-mini__tooltip">
            <a
              @click.prevent="selectSubMenu(item.path)"
              class="app-menu-mini__item"
              :class="{'app-menu-mini__active': activeName === item.path }">
              <Icon :type="item.meta.icon" v-if="item.meta.icon" />
              <Icon :custom="item.meta.customIcon" v-else />
            </a>
          </Tooltip>
        </div>
      </div>
    </vue-scroll>
  </div>
</template>
<script>
export default {
  name: 'AppMenu',
  data () {
    return {
      placement: 'right-start',
      subPlacement: 'right-start'
    }
  },
  watch: {
    openMenuNames () {
      this.$nextTick(() => this.$refs.menu.updateOpened())
    }
  },
  created () {
    //默认选中第一项
    this.$nextTick(() => {
      this.selectSubMenu(this.$store.getters.showMenu[0].path)
    })
  },
  computed: {
    activeName () {
      return this.$store.state.currentPath
    },
    openMenuNames () {
      const breadcrumb = this.$store.getters.breadcrumb || []
      if (breadcrumb.length > 1) {
        const openNames = []
        for (let i = 0; i < breadcrumb.length - 1; i++) {
          openNames.push(breadcrumb[i].name + (i === 1 ? ' ' : ''))
        }
        return openNames
      }
      return []
    },
    menu () {
      return this.$store.getters.showMenu
    },
    appBreakpoint () {
      return this.$store.state.appBreakpoint
    },
    isCollapsed () {
      return this.$store.state.isCollapsed
    },
    showMenuMini () {
      return this.isCollapsed && !this.appBreakpoint
    }
  },
  methods: {
    selectSubMenu (name) {
      this.$emit('selectMenu')
      this.$router.push(name).catch(err => {
        if (err.name != 'NavigationDuplicated') {
          console.error('路由跳转异常：', err)
        }
      })
    },
    handleMousemove (event, children, sub) {
      const { clientY } = event
      const height = children.length * 48
      const isOverflow = clientY + height < window.innerHeight
      if (sub) {
        this.subPlacement = isOverflow ? 'right-start' : 'right-end'
      } else {
        this.placement = isOverflow ? 'right-start' : 'right-end'
      }
    }
  }
}
</script>
<style lang="less">
  @import '../../assets/less/base/variables.less';
  .app-menu {
    height: 100%;
    background: @menu-dark-title;
    padding-top: 56px;
    &__single-item {
      &.ivu-menu-item-active {
        background: @primary-color !important;
        color: #fff !important;
      }
    }
  }
  .app-logo {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 56px;
    line-height: 56px;
    padding: 0 16px;
    text-align: center;
    background: @menu-dark-title;
    overflow: hidden;
	display: flex;
	justify-content: space-around;
	.title{
		color: white;
    font-weight: bold;
		font-size: 23px;
	}
    img {
      display: inline-block;
      width: 100%;
      vertical-align: middle;
      transition: all @animation-time;
    }
    h1 {
      display: inline-block;
      margin: 0 0 0 12px;
      color: #fff;
      font-weight: 600;
      font-size: 20px;
      transition: all @animation-time;
    }
  }
  .app-menu-mini {
    &__dropdown {
      display: block;
    }
    &__item {
      text-align: center;
      display: block;
      line-height: 48px;
      color: @menu-dark-subsidiary-color;
      &:hover {
        color: #fff;
      }
      .ivu-icon,
      .iconfont {
        font-size: 20px;
      }
    }
    &__active {
      background: @menu-dark-title;
      color: @primary-color !important;
    }
    &__transfer {
      min-width: 160px;
      background-color: @menu-dark-title !important;
      margin-left: 3px;
      max-height: none;
      .ivu-dropdown {
        display: block;
      }
      .ivu-dropdown-rel {
        cursor: pointer;
        padding: 7px 32px 7px 16px;
        a {
          color: @menu-dark-subsidiary-color;
          background: transparent !important;
        }
        .ivu-icon {
          position: absolute;
          top: 50%;
          right: 16px;
          transform: translateY(-50%);
        }
        &:hover a {
          color: #fff;
        }
      }
      .ivu-select-dropdown {
        min-width: 160px;
        background: @menu-dark-title;
        margin-left: 3px;
        max-height: none;
        .ivu-dropdown-item {
          color: @menu-dark-subsidiary-color;
          &:hover {
            background: transparent;
            color: #fff;
          }
          &.app-menu-mini__active {
            background-color: @primary-color;
            color: #fff !important;
          }
        }
      }
      &--sub{
        background: transparent;
        color: @menu-dark-subsidiary-color;
        &:hover {
          background: transparent;
          color: #fff;
        }
        &.app-menu-mini__active {
          background-color: @primary-color;
          color: #fff !important;
        }
      }
    }
    &__tooltip {
      display: block;
      text-align: center;
      .ivu-tooltip-rel {
        display: block;
      }
    }
  }
</style>
